enum EProductor {
  MGGroup = "MGGroup",
  Mutual18J = "Mutual18J",
  BDS = "BDS",
}

export const productores: Record<EProductor, string> = {
  [EProductor.MGGroup]: "MG GROUP",
  [EProductor.Mutual18J]: "MUTUAL",
  [EProductor.BDS]: "BDS",
};
